import cn from 'classnames'
import { memo } from 'react'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { Checkbox } from 'core-components/library/checkbox'
import { List } from 'shared/components/list'

import { IAvailableFlagProps } from './models'

import styles from './AvailableFlag.module.scss'

export const AvailableFlag = memo<IAvailableFlagProps>(
  ({ flag, isSelected, onSelect, isDisabled, isReadOnly }) => {
    const caption = flag.codeName || flag.code

    const comment = flag.comment || '-'

    const isUnavailable = Boolean(flag.comment)

    return (
      <List.Label
        className={cn(styles.item, {
          [styles.disabled]: isDisabled,
          [styles.unavailable]: isUnavailable,
        })}
        isDisabled={isDisabled}
      >
        <div className={styles.codeName}>
          <RenderWhen condition={!isReadOnly}>
            <Checkbox
              className={styles.checkbox}
              checked={isSelected}
              onChange={onSelect}
              size="sm"
              disabled={isDisabled || isUnavailable}
            />
          </RenderWhen>
          <span className={styles.caption}>{caption}</span>
        </div>
        <div className={styles.warning}>
          <RenderWhen condition={isUnavailable}>
            <span className={styles.comment}>{comment}</span>
          </RenderWhen>
        </div>
      </List.Label>
    )
  },
  (prevProps, nextProps) =>
    prevProps.isSelected === nextProps.isSelected && prevProps.isDisabled === nextProps.isDisabled
)

AvailableFlag.displayName = 'AvailableFlag'
